module.exports = __webpack_public_path__ + "bc6adc2cd9610fe382f95cb3a56315e6.svg";